import cx from "classnames";
import { FC } from "react";

import { DescriptiveTag } from "atoms/tag/DescriptiveTag";
import { formatToSimpleDate } from "utils/dayjsUtils";

export interface RetailProductOrderCardProps {
  name: string;
  imageUri?: string;
  totalQuantity?: number;
  quantity?: number;
  underline?: boolean;
  context?: "wallet" | "product-details";
  lastRedeemedOnUtc?: string;
  estimatedDeliveryDateAtUtc?: string;
  onClick?: () => void;
}

export const RetailProductOrderCard: FC<RetailProductOrderCardProps> = ({
  name,
  imageUri,
  totalQuantity,
  quantity,
  underline,
  context = "wallet",
  lastRedeemedOnUtc,
  estimatedDeliveryDateAtUtc,
  onClick,
}) => {
  return (
    <div className="mb-2 grid grid-cols-[60px_1fr] items-center gap-3">
      <div className="relative">
        {imageUri ? (
          <img
            src={imageUri}
            alt={name}
            className="size-[60px] rounded-lg border object-cover"
          />
        ) : (
          <div className="size-[60px] rounded-lg border bg-white" />
        )}
        {typeof quantity === "number" &&
          quantity > 0 &&
          totalQuantity &&
          totalQuantity > 1 && (
            <div className="absolute -right-2 -top-2">
              <DescriptiveTag color="primary" size="xsmall">
                {quantity.toString()}
              </DescriptiveTag>
            </div>
          )}
      </div>
      <div className="flex flex-col gap-2">
        <p
          role="button"
          tabIndex={0}
          className={cx(
            "font-serif text-body2",
            underline && context === "product-details" && "underline"
          )}
          onClick={onClick}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              onClick?.();
            }
          }}
        >
          {name}
        </p>
        {lastRedeemedOnUtc && context !== "wallet" && (
          <p className="text-body3">
            Picked up on {formatToSimpleDate(lastRedeemedOnUtc)}
          </p>
        )}
        {estimatedDeliveryDateAtUtc && context !== "wallet" && (
          <p className="text-body3">
            Delivered on {formatToSimpleDate(estimatedDeliveryDateAtUtc)}
          </p>
        )}
      </div>
    </div>
  );
};
